/**
 * Shared webwalker-core Axios client.
 *
 * - baseURL comes from VUE_APP_ROOT_API (baked at Vue CLI build time).
 * - Call Api() before each request so Authorization is set or cleared from
 *   the current Vuex token (login/logout can change mid-session).
 * - App code should import domain modules (AuthApi, ContactsApi, …), not Api
 *   directly.
 */
import axios from "axios";
import store from "@/store";

let CoreApi = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

let Api = function() {
  if (store.state.token) {
    CoreApi.defaults.headers.common["Authorization"] = 'Bearer ' + store.state.token;
  } else {
    delete CoreApi.defaults.headers.common["Authorization"];
  }

  return CoreApi;
};

export default Api;
